import { render, staticRenderFns } from "./DeliverablesInProjectList.vue?vue&type=template&id=e44bc1de&"
import script from "./DeliverablesInProjectList.vue?vue&type=script&lang=js&"
export * from "./DeliverablesInProjectList.vue?vue&type=script&lang=js&"
import style0 from "./DeliverablesInProjectList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports